import type { CallSummary } from '@smarton-pbx/shared';
import { parsePhoneNumberFromString } from 'libphonenumber-js/min';
import { t } from '../i18n';

// Shared with the phone app.
export { isEmergencyNumber, refusalText } from '@smarton-pbx/shared';

/** A phone number for people to read: "+370 520 00101". Extensions and anything unparsable stay as they are. */
export function formatNumber(value: string): string {
  if (!value.startsWith('+')) return value;
  return parsePhoneNumberFromString(value)?.formatInternational() ?? value;
}


type PillKind = 'success' | 'warning' | 'danger' | 'brand' | undefined;

/** How a call ended, as a short label and a colour. */
export function outcome(call: Pick<CallSummary, 'outcome' | 'answeredBy'>): { label: string; kind: PillKind } {
  switch (call.outcome) {
    case null:
      return { label: t('In progress'), kind: 'brand' };
    case 'ANSWERED':
      return { label: call.answeredBy === 'MOBILE' ? t('Answered on mobile') : t('Answered'), kind: 'success' };
    case 'MISSED':
      return { label: t('Missed'), kind: 'danger' };
    case 'VOICEMAIL':
      return { label: t('Voicemail'), kind: 'warning' };
    case 'NO_ANSWER':
      return { label: t('No answer'), kind: undefined };
    case 'BUSY':
      return { label: t('Busy'), kind: undefined };
    case 'REJECTED':
      return { label: t('Not allowed'), kind: 'danger' };
    case 'CANCELLED':
      return { label: t('Cancelled'), kind: undefined };
    default:
      return { label: t('Failed'), kind: 'danger' };
  }
}
